import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const ExportOptions = ({
  format,
  onFormatChange,
  metadata,
  onMetadataChange,
  onExport,
  disabled,
  sampleRate = 48000,
  bitDepth = 24,
  estimatedSizeBytes = null,
}) => {
  const formatOptions = [
    { value: 'wav-mp3', label: 'WAV + MP3 (recommended)', description: 'Studio-grade WAV 24-bit plus 320 kbps MP3' },
    { value: 'wav', label: 'WAV 24-bit only', description: 'Uncompressed, highest quality' },
    { value: 'mp3', label: 'MP3 320 kbps only', description: 'Compressed, smaller file' }
  ];

  const handleMetadataChange = (field, value) => {
    onMetadataChange({ ...metadata, [field]: value });
  };
  const formatFileSize = (bytes) => {
    if (!Number.isFinite(bytes) || bytes <= 0) return 'Pending';
    const mb = bytes / (1024 * 1024);
    return `~${mb >= 10 ? Math.round(mb) : mb.toFixed(1)} MB`;
  };
  const sampleRateLabel = `${(Number(sampleRate || 48000) / 1000).toFixed(Number(sampleRate) % 1000 === 0 ? 0 : 1)} kHz`;

  return (
    <div className="p-4 md:p-6 rounded-lg bg-card border border-border space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-1">Export Master</h3>
        <p className="text-sm text-muted-foreground">
          Choose format and add metadata
        </p>
      </div>

      {/* Format Selection */}
      <div className="space-y-2">
        <label className="text-sm font-medium">Export Format</label>
        <Select
          options={formatOptions}
          value={format}
          onChange={onFormatChange}
          placeholder="Select format"
        />
      </div>

      {/* Metadata Fields */}
      <div className="space-y-4 pt-4 border-t border-border">
        <h4 className="text-sm font-medium">Track Metadata</h4>
        
        <Input
          label="Artist"
          placeholder="Enter artist name"
          value={metadata?.artist}
          onChange={(e) => handleMetadataChange('artist', e?.target?.value)}
        />

        <Input
          label="Title"
          placeholder="Enter track title"
          value={metadata?.title}
          onChange={(e) => handleMetadataChange('title', e?.target?.value)}
        />

        <Input
          label="Album"
          placeholder="Enter album name"
          value={metadata?.album}
          onChange={(e) => handleMetadataChange('album', e?.target?.value)}
        />
      </div>

      {/* Export Info */}
      <div className="space-y-3 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">File Size</span>
          <span className="font-medium">{formatFileSize(estimatedSizeBytes)}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Sample Rate</span>
          <span className="font-medium">{sampleRateLabel}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Bit Depth</span>
          <span className="font-medium">{bitDepth}-bit</span>
        </div>
      </div>

      {/* Export Button */}
      <Button
        variant="default"
        size="lg"
        fullWidth
        onClick={onExport}
        disabled={disabled}
        iconName="Download"
        iconPosition="left"
      >
        Export Master
      </Button>

      {disabled && (
        <div className="flex items-start gap-2 p-3 rounded-lg bg-warning/10 text-warning">
          <Icon name="Info" size={16} className="mt-0.5" />
          <p className="text-xs">
            Complete the mastering process before exporting
          </p>
        </div>
      )}
    </div>
  );
};

export default ExportOptions;
